import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=4919efd2&scoped=true"
import script from "./frame.vue?vue&type=script&lang=js"
export * from "./frame.vue?vue&type=script&lang=js"
import style0 from "./frame.vue?vue&type=style&index=0&id=4919efd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4919efd2",
  null
  
)

export default component.exports